module.exports = "/images/zink-powered-by-ausloans.png?88ee274d205f8e91f43e5770297cec14";